import { Component } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { DialogResult } from '@app/Common/popup/dialog-result';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'add-saml-popup-dialog',
    templateUrl: './addSamlPopup.component.html',
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatFormField, MatInput, FormsModule, MatButton]
})
export class AddSamlPopup {
    public dialogTitle: string;
    public dialogDescription: string;
    public dialogConfirmButtonText: string;
    public dialogCancelButtonText: string;
    public displayTextBox: boolean;
    public metadataUrl: string;
    public name: string;
    public dialogResult: DialogResult = new DialogResult();

    constructor(public dialogRef: MatDialogRef<AddSamlPopup>) { }

    public closeDialog(result: boolean): void {
        this.dialogResult.Result = result;

        this.dialogResult.Text = JSON.stringify({ metadataUrl: this.metadataUrl, name: this.name });
        this.dialogRef.close(this.dialogResult);
    }
}
